import { DataBean } from "../DataBean";

export class ActaComite extends DataBean {

    public async getActaComiteCatalogPorPropiedades(properties: any,maxRows: number ): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getActaComiteCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }
    public async getActaComiteRender(idActa: number ): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getActaComiteRender_Number", 
            [idActa]
        );
    }
    public async getActaComiteResumen(page: number ,rows:number,props:any,fromDate:any,uptoDate:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getActaComiteResumen_Number_Number_java.util.Map_java.util.Date_java.util.Date", 
            [page,rows,props,fromDate,uptoDate]
        );
    }
    public async contabilizarActaCredito(idActaComite:number,idCustomProcessType:number,approvalDate:any,idEmployee:number): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_contabilizarActaCredito_Number_Number_java.util.Date_Number", 
            [idActaComite,idCustomProcessType,approvalDate,idEmployee]
        );
    }
    public async registerCreditActa(idActaComite:number,fechaDesembolso:any,idEmployee:number): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_registerCreditActa_Number_java.util.Date_Number", 
            [idActaComite,fechaDesembolso,idEmployee]
        );
    }



}
